import { h } from 'preact'
import Content from '../common/Content'

type Props = {
  subject: string,
  content: string,
  fromUsername: string,
  fromEmail: string,
  onPreviewClicked: () => void,
  template: string | null
}

const CreateEmailForm = ({ subject, content, fromUsername, fromEmail, onPreviewClicked, template } : Props) => (
  <div className='create-email-campaign__preview' onClick={onPreviewClicked}>
    <div className='create-email-campaign__preview-header'>
      <div className='circle circle--red' /><div className='circle circle--orange' /><div className='circle circle--green' />
    </div>
    <div className='create-email-campaign__preview-subject'>
      <div>Subject</div>
      {
        subject
          ? <div className='create-email-campaign__preview-input'><div dangerouslySetInnerHTML={{ __html: subject }} /></div>
          : <div className='create-email-campaign__preview-placeholder'>Enter email subject</div>
      }
    </div>
    <div className='create-email-campaign__preview-from'>
      <div>From</div>
      <div className='create-email-campaign__preview-input'>{fromUsername}</div>
      <div className='create-email-campaign__preview-meta'>&nbsp;&lt;{fromEmail} via amazonses.com&gt;</div>
    </div>
    <Content
      content={template ? template.replace('{content}', content) : content}
      className='post__content--email'
    />
  </div>
)

export default CreateEmailForm
